var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "#E03C31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49 9.65H7.365L7.245 3.605H8.625L8.49 9.65ZM7.935 11.855C7.725 11.855 7.55 11.785 7.41 11.645C7.27 11.505 7.2 11.33 7.2 11.12C7.2 10.91 7.27 10.735 7.41 10.595C7.55 10.455 7.725 10.385 7.935 10.385C8.145 10.385 8.32 10.455 8.46 10.595C8.6 10.735 8.67 10.91 8.67 11.12C8.67 11.33 8.6 11.505 8.46 11.645C8.32 11.785 8.145 11.855 7.935 11.855Z",
    fill: "#E03C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.734e91095cbeefc3ebe1774d1b8ca3fc.svg";
export { ForwardRef as ReactComponent };